'use client';
import React from 'react';

import { StockSymbol } from '@benzinga/session';
import { getQuoteChange, Quote } from '@benzinga/quotes-v3-manager';
import { PerformanceColor, PerformanceColorV2 } from '../Ticker/PerformanceColor';
import { useQuoteSubscriptionCallback } from '@benzinga/quotes-v3-manager-hooks';

interface Props {
  onSymbolClick: (symbol: StockSymbol) => void;
  symbol: StockSymbol;
  symbolLabel?: string;
}

export const TickerColor: React.FC<Props> = ({ onSymbolClick, symbol, symbolLabel }) => {
  const openSymbolDetails = React.useCallback(() => {
    onSymbolClick?.(symbol);
  }, [onSymbolClick, symbol]);

  const [stat, setStat] = React.useState(0);
  const fields = React.useMemo<Set<keyof Quote>>(() => new Set(['symbol', 'change']), []);

  useQuoteSubscriptionCallback(
    symbol,
    fields,
    React.useCallback((quote: Quote | undefined) => {
      if (quote) {
        setStat(Math.sign(Number(getQuoteChange(quote).nominalChange ?? 0)));
      }
    }, []),
  );

  return <PerformanceColor label={symbolLabel ?? symbol} onClickHandler={openSymbolDetails} stat={stat} />;
};

export const TickerColorV2: React.FC<Omit<Props, 'onSymbolClick'>> = ({ symbol, symbolLabel }) => {
  const [stat, setStat] = React.useState(0);
  const fields = React.useMemo<Set<keyof Quote>>(() => new Set(['symbol', 'change']), []);

  useQuoteSubscriptionCallback(
    symbol,
    fields,
    React.useCallback((quote: Quote | undefined) => {
      if (quote) {
        setStat(Math.sign(Number(getQuoteChange(quote).nominalChange ?? 0)));
      }
    }, []),
  );

  return <PerformanceColorV2 label={symbolLabel ?? symbol} stat={stat} />;
};

TickerColor.displayName = 'TickerColor';
